module.exports = __webpack_public_path__ + "img/Asset2.8043ebf6.png";